<div v-safe-html="html"></div>